$(document).ready(function() {
  $('.gallery__carousel').slick({
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    pauseOnFocus: true,
    pauseOnHover: false,
    arrows: true,
    dots: true,
    responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1
      }
    }
    ]
  });

  $('.gallery__carousel').slickLightbox({
    caption: 'caption'
  });
});